import type { TutorielVideo } from '@/types/videoTutorials';

const tutorielsVideoData: Partial<Record<string, TutorielVideo[]>> = {
  Suravenir: [
    { operation: 'versement', videoId: 'JhyD-OsiMuM', duree: '2:56' },
    { operation: 'arbitrage', videoId: 'ctJnRInQspA', duree: '1:30' },
    { operation: 'rachat', videoId: 'lT3a8p3Kj0A', duree: '2:16' },
  ],
  Spirica: [
    { operation: 'versement', videoId: 'mCEl-dXYRjU', duree: '4:51' },
    { operation: 'arbitrage', videoId: 'tTHVrZ86ezM', duree: '3:29' },
    { operation: 'rachat', videoId: 'G7-HuQfbAiw', duree: '1:58' },
  ],
  Generali: [
    { operation: 'versement', videoId: 'Qqh3Z9lPCuY', duree: '3:41' },
    { operation: 'arbitrage', videoId: 'HjBkPFyjv2Y', duree: '2:19' },
    { operation: 'rachat', videoId: 'Bze6dSfPUQU', duree: '1:53' },
  ],
};

export default tutorielsVideoData;
